import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../../utils/checkout';
import { pricingRows, pricingTrustItems } from '../../data/pricing';
export function Pricing() {
  return <section id="oferta-base" className="bg-white py-10 sm:py-14" data-id="element-167" data-mp="3gijjanzpi1ed">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-168" data-mp="3gkw91nbphg1z">
        <SectionTag icon="💰" data-id="element-169" data-mp="3lh4j4mb1qj2a">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-170" data-mp="3pj7wxhl6tzqq">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-171" data-mp="3ugrkj83rzovc">
          Acceso inmediato y garantía total de 7 días.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-172" data-mp="205cusrarlpfl">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border-2 border-naranja bg-bg-secondary p-6 shadow-card sm:p-7" data-id="element-173" data-mp="206w9wekopufs">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-174" data-mp="16hx8128w6isw">
            🏐 VOLEY-PRO 360 — Sistema Sesión en Mano
          </p>
          <p className="mt-1.5 text-xs text-muted" data-id="element-175" data-mp="xkd93zyi4ylg">6 tomos + 5 bonos, listos para tus entrenamientos.</p>

          <ul className="mt-4 space-y-1.5 text-left text-sm text-gris-oscuro" data-id="element-176" data-mp="1u8b5j8a8x9uv">
            <li className="flex items-start gap-2" data-id="element-177" data-mp="1pa9m2m8wr8iv">
              <CheckIcon size={14} className="mt-0.5 flex-shrink-0 text-success" data-id="element-178" data-mp="1p8oqctauxjjf" />
              <span data-id="element-179" data-mp="1l7378q7qc90s">6 tomos + 5 bonos · 11 PDF · 414 páginas</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-180" data-mp="1g91qibxs0lsh">
              <CheckIcon size={14} className="mt-0.5 flex-shrink-0 text-success" data-id="element-181" data-mp="9thj98dlwdgu" />
              <span data-id="element-182" data-mp="9reknzye1c0i">Sesiones completas + Sesiones express</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-183" data-mp="4td0fbp876ng">
              <CheckIcon size={14} className="mt-0.5 flex-shrink-0 text-success" data-id="element-184" data-mp="6bk1fq7jba2m" />
              <span data-id="element-185" data-mp="bao8obawexqb">64 fichas técnicas, 40 tareas colectivas y 30 juegos para base</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-186" data-mp="3th2mma9637op">
              <CheckIcon size={14} className="mt-0.5 flex-shrink-0 text-success" data-id="element-187" data-mp="3tg9p7zw3luj8" />
              <span data-id="element-188" data-mp="1bfmw5q6spf1">Rotaciones, planificación de temporada y fichas imprimibles</span>
            </li>
          </ul>
          <p className="mt-3 text-xs leading-relaxed text-muted" data-id="element-189" data-mp="3jpf1ss748ow7">
            Un material organizado para decidir qué trabajar, cómo montarlo y qué ajustar cuando el equipo
            necesita otro nivel de dificultad.
          </p>

          <div className="mt-4 space-y-1.5" data-id="element-190" data-mp="3erdhy51v8ljo">
            {pricingRows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-gris-claro py-1.5 text-sm" data-id="element-191" data-mp="30rvp9elg8o51">
                <span className="text-gris-oscuro" data-id="element-192" data-mp="35t1iddj0udf3">{row.content}</span>
                <span className="flex flex-shrink-0 items-center gap-2" data-id="element-193" data-mp="2m5yd60an52du">
                  {row.value !== '∞' && <span className="text-muted" data-id="element-194" data-mp="2h7dmarha3v22">{row.value}</span>}
                  {row.value === '∞' && <span className="text-muted" data-id="element-195" data-mp="2v6whykswldxh">{row.value}</span>}
                  <CheckIcon size={14} className="text-success" data-id="element-196" data-mp="2r49mm9x0xavj" />
                </span>
              </div>)}
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-azul-dark" data-id="element-197" data-mp="353hqhg44t762">
              <span data-id="element-198" data-mp="305pti7omquv0">VALOR TOTAL</span>
              <span className="text-rojo line-through" data-id="element-199" data-mp="304obtkd3za4b">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-200" data-mp="3evx5c4k4tfmq">Precio hoy (85% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-azul sm:text-6xl" data-id="element-201" data-mp="39vj5h9sopbzs">17,99€</p>
          <p className="mt-1 text-xs text-muted" data-id="element-202" data-mp="3nv20r20ecsuo">Se cobrará en la moneda de tu país según tu método de pago.</p>
          <span className="mt-2 inline-block rounded-full bg-naranja-light px-3 py-1 text-sm font-semibold text-black" data-id="element-203" data-mp="3itcq3nh36h74">
            ⏰ Precio de lanzamiento — sube pronto
          </span>

          <div className="mt-6" data-id="element-204" data-mp="1m3s2twvt4xvq">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl border-2 border-naranja bg-gradient-to-br from-azul to-azul-dark px-8 py-4 font-heading text-base font-semibold uppercase tracking-wide text-white shadow-card transition-[filter] duration-200 hover:brightness-90 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-azul focus-visible:ring-offset-2 focus-visible:ring-offset-white sm:text-lg" data-id="element-205" data-mp="1qw1qf69g9luu">
              Quiero Voley-Pro 360 por 17,99€
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-206" data-mp="2in9bg4kc3pp6">
            {pricingTrustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-207" data-mp="2nl108ppomvp5">
                <item.icon size={12} data-id="element-208" data-mp="2xqisbqvwz5c9" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}